__turbopack_context__.v({
  "activity-indicator-wrapper": "ActivityIndicator-module-scss-module__U2ylSG__activity-indicator-wrapper",
  "activity-indicator-wrapper--active": "ActivityIndicator-module-scss-module__U2ylSG__activity-indicator-wrapper--active",
});
